export const hashCode = (value: string): string => {
  const reducer = (a: number, b: string) => {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  };

  return `${value.split('').reduce(reducer, 0)}`;
};
